<template lang="pug">
.bq-bunny-loader(:class="{ 'bq-bunny-loader--overlay': overlay }" aria-hidden="true" translate="no")
    AsciiBanner(:motions="LOADER_MOTIONS" :rest-ms="LOADER_REST_MS" :font-size="LOADER_FONT_SIZE")
    .bq-bunny-loader__label(v-if="label") {{ label }}
</template>

<script setup lang="ts">
import AsciiBanner from "@/components/asciiBanner.vue";

// The generic "working" indicator: the Skapi wordmark drawn as text, swept
// in once and then cycling, with an optional caption under it.
//
// Two layouts, picked by `overlay`:
//   overlay (default) = absolute inset:0 over the nearest positioned parent,
//     above the content it hides (z-index 4), click-through.
//   in-flow (:overlay="false") = a centred block that takes its own space
//     (login hanger, articles, project list, empty states).
// Call sites may add their own class on the root (project-list.vue passes
// .bq-empty-mark); it falls through onto the root element as usual.
withDefaults(defineProps<{ label?: string; overlay?: boolean }>(), {
    overlay: true,
});

// One preset for every loader on the site, the full screen one included
// (jsComponents.ts mounts this component for it). Storm and press only: the
// jitter reads as a fault rather than as work in progress. 10px puts the 44
// column grid at about 250px, which still clears a 320px phone and keeps the
// strokes apart; at 8px the dense runs of `$` start to merge.
const LOADER_MOTIONS = ["storm", "press"];
const LOADER_REST_MS = 400;
const LOADER_FONT_SIZE = "10px";
</script>

<style lang="less">
@import "@/assets/less/bq-tokens.less";

.bq-bunny-loader {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
}

.bq-bunny-loader--overlay {
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 4;
}

.bq-bunny-loader__label {
    color: @muted;
    font-family: @mono;
    font-size: 0.83rem;
    text-align: center;
}
</style>
